import React, { useEffect } from "react"
import { Box, Grid, Typography } from "@mui/material"
import profileimage from "../../images/personal-info.svg"
import * as Style from "./Style"
import StepperComponent from "./Stepper"
import { useAppDispatch } from "../../app/hooks"
import { resetString } from "../../features/Auth/WrapperSlice"
const StepperLayout = () => {
  
  const dispatch = useAppDispatch()
  // const [activeStep, setActiveStep] = React.useState(0)
  // const [skipped, setSkipped] = React.useState(new Set<number>())

  // const isStepOptional = (step: number) => {
  //   return step === 1
  // }

  // const isStepSkipped = (step: number) => {
  //   return skipped.has(step)
  // }

   useEffect(() => {
  
    return () => {
      //
      dispatch(resetString())
    }
  }, [])
  return (
    <Style.PersonalInfo>
      <Grid container>
        <Grid item md={4} className="d-none d-lg-block">
          <Box className="profile-box">
            <Typography variant="h2" className="profile-title pink-text pb-4">
              Create Your Profile
            </Typography>
            <Typography variant="h6" className="sub-title pb-2">
              A Few Clicks Away From Creating Your Profile
            </Typography>
            <Typography className="paragraph">
              Are You A Multitasking Mom Looking For Reliable Help With
              Babysitting, Housekeeping, And More? Look No Further! Join Our
              Community Of Empowered Moms Who Have Found The Perfect Solution To
              Balance Work, Family, And Personal Time
            </Typography>
            <Box className="profile-image">
              <img src={profileimage} className="image-size" />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={8}>
          <StepperComponent />
        </Grid>
      </Grid>
    </Style.PersonalInfo>
  )
}

export default StepperLayout
